const CMSFICTEmployees =  [
    "000c1973-d837-4e9a-ab81-dc6426b89fa6",
    "1ce81561-dfcb-457d-9ac6-402c44788c05",
    "32bfc16e-85e2-4c18-ba5c-97e049d035e0",
    "3f2ae393-bef8-4b94-8fbd-f9e3aa27e861",
    "67ad60a1-1522-4f1c-8bc9-e29fd198ea4b",
    "84b82948-064a-4987-a73a-33258943721b",
    "86f42b01-f420-4be3-b035-f25234205df8",
    "d51437e6-ff7f-4760-b9d9-799553120f26",
    "ed16ee8f-b3f1-4acc-8963-5b79d2471253",
    "db0be741-1780-4d5f-87b6-db765ad8af5f"
];
  export default CMSFICTEmployees;